const yellow100 = '#DE9F1E'
export const colors = {
  dark: { secondary: { yellow100 } },
  light: { secondary: { yellow100 } },
}
